/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import * as userAuthApiActions from './user-auth-api.actions';
import { observableOf } from 'app/shared/rxjs/rxjs.utils';
import { AuthService } from 'app/user-auth/services/auth.service';

@Injectable()
export class UserAuthApiEffects {
  /** Login API trigger. */

  login: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(userAuthApiActions.USER_LOGIN),
      switchMap(() =>
        this.authService.authenticate().pipe(
          map(result => new userAuthApiActions.UserLoginSuccess(result)),
          catchError(err => observableOf(new userAuthApiActions.UserLoginError(err)))
        )
      )
    )
  );

  /** Log user out when authentication fails. */

  loginFail = createEffect(
    () =>
      this.actions.pipe(
        ofType(userAuthApiActions.USER_LOGIN_ERROR),
        tap(() => this.authService.unauthenticate())
      ),
    { dispatch: false }
  );

  constructor(private actions: Actions, private authService: AuthService) {}
}
